// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__25Qvq","col":"Table_col__1HyOr","fulfillmentStatus":"Table_fulfillmentStatus__1vAXJ","emailCol":"Table_emailCol__37L7I"};